import { Button, Card, Col, Container, Row } from "react-bootstrap";
import "./index.css";
import { FaYoutube } from "react-icons/fa";
import { IoTimeOutline } from "react-icons/io5";
import { LiaUserGraduateSolid } from "react-icons/lia";

function Allcourse() {
  let data = [
    {
      id: 1,
      title: "Python Advance Programming Course",
      description: "Welcome to the Python Programming course! In this comprehensive and engaging course, we will dive into the world of Python programming and equip you with the knowledge and skills necessary to become a proficient Python developer. Whether you're a beginner with no prior programming experience or an experienced coder looking to expand your skill set, this course is designed to cater to learners of all levels. Throughout this course, we will cover the fundamentals of Python programming, starting with the basics and gradually progressing to more advanced topics. You will learn about variables, data types, control flow structures (such as loops and conditional statements), functions, and object-oriented programming (OOP) concepts.",
      pth: require("./assest/Python.png")
    },
    {
      id: 2,
      title: "JavaScript Advance Course",
      description: "JavaScript is one of the most popular programming languages in the world, and it's used to create everything from websites to mobile apps. In this course, you'll learn the",
      pth: require("./assest/JawaSCRIPT.png")
    },
    {
      id: 3,
      title: "Video Editing Course - Adobe Premiere Pro",
      description: "Welcome to the comprehensive Adobe Premiere Pro course, where you'll gain the skills and expertise to become a proficient video editor. Whether you're a beginner or",
      pth: require("./assest/adobe.png")
    },
    {
      id: 4,
      title: "Digital Marketing Course - Facebook Ads",
      description: "In this course, you will learn how to create and manage Facebook ads that will help you reach your target audience and achieve your",
      pth: require("./assest/facebook.png")
    },
    {
      id: 5,
      title: "HTML & CSS Full Course",
      description: "Unlock the essentials of web development with our HTML & CSS course by azad chaiwala. Dive into the building blocks of",
      pth: require("./assest/html+css.png")
    },
    {
      id: 6,
      title: "Digital Marketing Course - Google Ads",
      description: "Supercharge your digital marketing skills with the free Google Ads course by Azad Chaiwala. Unlock the power of Google's",
      pth: require("./assest/googleads.png")
    },
    {
      id: 7,
      title: "Adobe Photoshop Course for Graphic Designers",
      description: "The Adobe Photoshop course is a comprehensive and hands-on learning experience designed to equip students with the essential skills needed to harness the",
      pth: require("./assest/photoshop adobe.png")
    },
    {
      id: 8,
      title: "Game Development Course (Unity 3D)",

      description: "Dive into the world of game development, from concept to creation free beginner's course by Azad Chaiwala. Learn game design",
      pth: require("./assest/game development.png")
    },
    {
      id: 9,
      title: "Shopify Course",
      description: "With our comprehensive Shopify Course. Dive into the world of online retail and master the art of setting up, managing, and",
      pth: require("./assest/shopify.png")
    },
    {
      id: 10,
      title: "MERN Stack Course for Web Development",
      description: "Embark on your journey to become a MERN stack developer with the free beginner's course by Azad Chaiwala. Dive into the world",
      pth: require("./assest/mern full stack.png")
    },
    {
      id: 11,
      title: "WordPress Course for Beginners",
      description: "Discover the power of WordPress with the free beginner's course by Azad Chaiwala. Learn the essentials of building and managing your own website with 19",
      pth: require("./assest/wordpress.png")
    },
    {
      id: 12,
      title: "COREL Draw Course for Graphic Designers",
      description: "Unlock your creative potential with the free beginner's CorelDRAW course by Azad Chaiwala. Dive into the world of graphic",
      pth: require("./assest/coreldraw.png")
    }
  ];

  return (
    <Container className="my-4">
      <Row>
        {data.map((item) => (
          <Col key={item.id} md={4} className="mb-4">
            <Card className="cardstyle h-100">
              <Card.Img variant="top" src={item.pth} alt={item.title} />
              <Card.Body>
                <Card.Title>{item.title}</Card.Title>
                <Card.Text >{item.description}</Card.Text>

              </Card.Body>
              <Button variant="primary">Go somewhere</Button>
              <div className="d-flex justify-content-around">
                <span ><FaYoutube />
                  11 lesson
                </span>
                <span ><IoTimeOutline />
                  56hours
                </span>
                <span ><LiaUserGraduateSolid />
                  1000 Graduates
                </span>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default Allcourse;